import { Wysiwyg } from "../components/wysiwyg/Wysiwyg";
import InputImageUpload from "../components/upload/Upload";
import { RenderCode } from "../components/RenderCode/RenderCode";
import IframeCustomForm from "../components/IframeCustomForm";
import ShadowEmbed from "../components/ShadowEmbed/ShadowEmbed";
import ShadowEmbedWrapper from "../components/ShadowEmbed/ShadowEmbedWrapper";
import { MicroFrontendForm } from "../MicroFrontendForm";
import { RemoteSelect } from "../components/remote-select/RemoteSelect";
import { RenderMasterdataSelect } from "../components/masterdata-select/RenderMasterdataSelect";
import { DateInput } from "../components/date-input/DateInput";
import { MultipleRemoteSelect } from "../components/remote-select/MultipleRemoteSelect";

const fieldConfig = [
    {
        ui_type: 'INPUT_RICH_TEXT',
        renderComponent: (props: any) => {
            return (
                <div>
                    <Wysiwyg props={props} />
                </div>
            );
        },
    },
    {
        ui_type: 'LAYOUT_SPACER',
        renderComponent: (props: any) => {
            return (
                <div
                    className="w-full flex items-center justify-center text-slate-400 text-xs"
                    style={{ height: props.item.height }}
                >
                    &nbsp;
                </div>
            );
        },
    },
    {
        ui_type: 'LAYOUT_SEPARATOR',
        renderComponent: (props: any) => {
            return <hr />;
        },
    },
    {
        ui_type: 'INPUT_FILE_UPLOAD',
        renderComponent: (props: any) => {
            return <InputImageUpload
                props={props} />;
        },
    },
    {
        ui_type: 'HTML_CUSTOM_FORM',
        renderComponent: (props: any) => {
            return <RenderCode props={props} />;
        },
    },

    {
        ui_type: 'IFRAME_CUSTOM_FORM',
        renderComponent: (props: any) => {
            return <IframeCustomForm props={props} />;
        },
    },
    {
        ui_type: 'SHADOW_EMBED',
        renderComponent: (props: any) => {
            return <ShadowEmbedWrapper props={props} />;
        },
    },
    {
        ui_type: 'EXTERNAL_MICRO_FRONTEND_FORM',
        renderComponent: (props: any) => {
            return <MicroFrontendForm props={props} />;
        },
    },
    {
        ui_type: 'REMOTE_SELECT',
        renderComponent: (props: any) => {
            return <RemoteSelect props={props} />;
        },
    },
    {
        ui_type: 'REMOTE_MULTI_SELECT',
        renderComponent: (props: any) => {
            return <MultipleRemoteSelect props={props} />;
        },
    },
    {
        ui_type: 'REMOTE_MASTERDATA_SELECT',
        renderComponent: (props: any) => {
            return <RenderMasterdataSelect props={props} />;
        },
    },
    {
        form_field_type: 'INPUT_DATE',
        renderComponent: (props: any) => {
            return <DateInput props={props} />;
        },
    },
    {
        form_field_type: 'INPUT_DATETIME-LOCAL',
        renderComponent: (props: any) => {
            return <DateInput props={props} />;
        },
    },

] as any;



export const useUiCustomComponent = () => {
    return {
        fieldConfig
    };
}
